var _style, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg02Lighting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    width: 158.581,
    height: 165.861,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st12{fill:#fff}.st187{fill:#ffcf00}.st188{fill:#252527}.st189{fill:#666}")), /*#__PURE__*/React.createElement("g", {
    id: "g1047",
    transform: "translate(-562.42 -774.33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M711.035 841.354c-13.251-15.713-43.803 7.211-51.315-12.294-8.911-23.139-27.547-49.813-50.519-33.593-19.833 14.004-3.414 37.958-19.855 51.074-8.561 6.83-36.026 9.645-23.872 36.756 6.096 13.598 6.135 19.314 18.96 24.399 25.005 9.914 35.02-9.817 56.918-14.88 20.167-4.662 43.174 22.617 63.087 8.184 19.333-14.012 22.013-41.364 6.596-59.646z",
    id: "path962",
    style: {
      fill: "#ecf0f1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1008"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st187",
    d: "M628.784 904.722c.134 0 .267-.008.401-.01.134.002.266.01.401.01 17.926 0 32.458-14.532 32.458-32.458 0-10.045-4.339-19.022-11.505-24.974-2.483-2.063-8.08-3.952-8.08-8.223V820.17c0-.999-.472-2.472-2.262-3.506-2.599-1.502-5.277-1.302-6.837-1.302h-8.348c-1.56 0-3.787-.2-6.386 1.302-1.79 1.035-1.812 2.705-1.812 3.506v18.897c0 4.27-6.048 6.16-8.531 8.223-7.167 5.952-11.844 14.929-11.844 24.974-.001 17.926 14.419 32.458 32.345 32.458z",
    id: "path964"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st188",
    id: "rect966",
    d: "M636.413 774.33h2.982v33.402h-2.982z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1006"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g972"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st189",
    cx: 638.193,
    cy: 811.039,
    rx: 7.213,
    ry: 3.306,
    id: "ellipse968"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M638.193 815.339c-4.679 0-8.207-1.849-8.207-4.3 0-2.451 3.528-4.3 8.207-4.3s8.207 1.848 8.207 4.3-3.528 4.3-8.207 4.3zm0-6.612c-3.796 0-6.219 1.369-6.219 2.312 0 .943 2.423 2.312 6.219 2.312 3.796 0 6.219-1.369 6.219-2.312 0-.943-2.423-2.312-6.219-2.312z",
    id: "path970"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st187",
    d: "M637.158 904.722c.134 0 .267-.008.401-.01.134.002.266.01.401.01 17.926 0 32.458-14.532 32.458-32.458 0-10.045-4.339-19.022-11.505-24.974-2.483-2.063-8.08-3.952-8.08-8.223V820.17c0-.999-.472-2.472-2.262-3.506-2.599-1.502-5.277-1.302-6.837-1.302h-8.348c-1.56 0-3.787-.2-6.386 1.302-1.79 1.035-1.812 2.705-1.812 3.506v18.897c0 4.27-6.048 6.16-8.531 8.223-7.167 5.952-11.843 14.929-11.843 24.974-.001 17.926 14.418 32.458 32.344 32.458z",
    id: "path974"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M639.183 816.664c1.79 1.034 2.262 2.507 2.262 3.506v18.897c0 4.27 5.597 6.16 8.08 8.223 7.167 5.952 11.505 14.929 11.505 24.974 0 16.374-12.127 29.909-27.888 32.132 1.492.211 3.016.327 4.568.327.134 0 .267-.008.401-.01.134.002.266.01.401.01 17.926 0 32.458-14.532 32.458-32.458 0-10.045-4.339-19.022-11.505-24.974-2.483-2.062-8.08-3.952-8.08-8.223v-18.897c0-.999-.472-2.472-2.262-3.506-2.599-1.502-5.277-1.302-6.837-1.302h-8.175c1.47.042 3.29.271 5.072 1.301z",
    id: "path976"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M632.332 815.362c.244 0 .517-.005.811-.007a20.173 20.173 0 0 0-.879.007h.068z",
    id: "path978"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M623.785 836.47h29.52v-18.234c0-1.137-.543-2.812-2.604-3.989-2.992-1.708-6.074-1.482-7.87-1.482h-9.609c-1.796 0-4.359-.227-7.351 1.482-2.061 1.177-2.085 3.077-2.085 3.989l-.001 18.234z",
    id: "path980",
    style: {
      fill: "gray"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M653.305 827.284v-9.427c0-.999-.544-2.472-2.608-3.506-2.995-1.502-6.082-1.302-7.88-1.302h-9.622c-1.798 0-4.365-.2-7.361 1.302-.36.18-.639.384-.885.595 11.19.971 21.157 5.534 28.356 12.338z",
    id: "path982"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M638.537 905.716c-.086 0-.172-.003-.258-.006l-.155-.004-.13.004c-.086.003-.172.006-.258.006-18.383 0-33.339-15.006-33.339-33.452 0-9.917 4.448-19.298 12.202-25.739.748-.622 1.746-1.201 2.801-1.815 2.517-1.463 5.37-3.122 5.37-5.643v-3.591h27.634v3.591c0 2.587 2.737 4.259 5.152 5.733.956.584 1.859 1.135 2.569 1.725 7.54 6.262 11.864 15.644 11.864 25.739 0 18.446-15.006 33.452-33.452 33.452zm-.413-1.998.226.006c.062.002.125.005.188.005 17.349 0 31.464-14.115 31.464-31.464 0-9.502-4.063-18.326-11.147-24.21-.599-.497-1.442-1.012-2.335-1.557-2.719-1.661-6.104-3.727-6.104-7.43v-1.603h-23.658v1.603c0 3.665-3.526 5.714-6.359 7.362-.982.571-1.909 1.11-2.53 1.626-7.299 6.062-11.485 14.886-11.485 24.21 0 17.349 14.064 31.464 31.351 31.464.063 0 .125-.002.188-.005z",
    id: "path984"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M654.299 837.464h-31.508v-19.891c0-.83 0-3.033 2.308-4.367 2.573-1.487 4.786-1.459 6.404-1.44.166.002.326.004.48.004h12.222c.151 0 .312-.002.482-.004 1.703-.021 4.274-.05 6.852 1.44 2.49 1.439 2.759 3.533 2.759 4.367v19.891zm-29.52-1.988h27.532v-17.903c0-.489-.172-1.725-1.766-2.646-2.106-1.217-4.262-1.191-5.835-1.173-.179.002-.348.004-.505.004h-12.222c-.161 0-.33-.002-.504-.004-1.463-.018-3.284-.04-5.385 1.173-1.213.701-1.315 1.733-1.315 2.646z",
    id: "path986"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M616.275 877.583a.994.994 0 0 1-.975-.806 23.837 23.837 0 0 1 .186-9.887.994.994 0 1 1 1.936.452 21.847 21.847 0 0 0-.17 9.058.995.995 0 0 1-.977 1.183z",
    id: "path988"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M638.479 895.878a23.579 23.579 0 0 1-21.746-14.402.994.994 0 0 1 1.83-.776 21.594 21.594 0 0 0 19.916 13.19.994.994 0 1 1 0 1.988z",
    id: "path990"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M647.758 865.038c-1.283 0-2.543-.563-3.456-1.544-.713-.766-1.562-2.158-1.562-4.439v-2.751a31.888 31.888 0 0 0-4.354-.408 29.817 29.817 0 0 0-4.878.452v2.706c0 2.277-.832 3.667-1.53 4.432-.899.986-2.142 1.551-3.409 1.551-1.957 0-3.937-1.432-3.937-4.169 0-3.511 3.445-5.251 6.889-6.114V836.47h1.988v17.875a32.49 32.49 0 0 1 4.878-.436c.202 0 2.073.012 4.354.372V836.47h1.988v18.203c3.454.832 7.026 2.569 7.026 6.196-.001 2.737-2.011 4.169-3.997 4.169zm-3.03-8.318v2.335c0 1.294.356 2.361 1.03 3.085.538.578 1.267.91 2 .91.926 0 2.008-.571 2.008-2.181 0-2.24-2.426-3.472-5.038-4.149zm-13.208.072c-2.639.725-4.901 1.98-4.901 4.078 0 1.61 1.05 2.181 1.95 2.181.71 0 1.417-.329 1.94-.903.661-.725 1.011-1.794 1.011-3.092z",
    id: "path992"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g1004"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    id: "rect994",
    d: "M632.547 835.973h20.758v.994h-20.758z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-13.615 642.496 833.296)",
    className: "st188",
    id: "rect996",
    d: "M631.964 832.958h21.357v.994h-21.357z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-13.615 642.496 828.272)",
    className: "st188",
    id: "rect998",
    d: "M631.964 827.932h21.357v.994h-21.357z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-13.615 642.496 823.247)",
    className: "st188",
    id: "rect1000",
    d: "M631.964 822.906h21.357v.994h-21.357z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-13.615 642.688 818.56)",
    className: "st188",
    id: "rect1002",
    d: "M631.964 817.881h21.357v.994h-21.357z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "light_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1030"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M692.044 905.036a.487.487 0 0 1-.248-.067l-18.786-10.846a.497.497 0 1 1 .497-.861l18.786 10.846a.497.497 0 0 1-.249.928z",
    id: "path1010"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M673.259 853.698a.496.496 0 0 1-.249-.928l18.786-10.846a.496.496 0 1 1 .497.861l-18.786 10.846a.494.494 0 0 1-.248.067z",
    id: "path1012"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M584.34 905.036a.496.496 0 0 1-.249-.928l19.412-11.207a.497.497 0 1 1 .497.861l-19.412 11.208a.51.51 0 0 1-.248.066z",
    id: "path1014"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M600.23 939.694a.497.497 0 0 1-.43-.746l3.254-5.636a.497.497 0 1 1 .861.497l-3.254 5.636a.496.496 0 0 1-.431.249z",
    id: "path1016"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M607.099 927.796a.496.496 0 0 1-.43-.745l11.208-19.412a.497.497 0 1 1 .861.497l-11.208 19.412a.497.497 0 0 1-.431.248z",
    id: "path1018"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M700.376 873.22h-21.692a.498.498 0 0 1 0-.994h21.692a.498.498 0 0 1 0 .994z",
    id: "path1020"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M568.777 873.22h-3.615a.498.498 0 0 1 0-.994h3.615a.498.498 0 0 1 0 .994z",
    id: "path1022"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M711.222 873.22h-3.615a.498.498 0 0 1 0-.994h3.615a.498.498 0 0 1 0 .994z",
    id: "path1024"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M598.423 873.22h-22.415a.498.498 0 0 1 0-.994h22.415a.498.498 0 0 1 0 .994z",
    id: "path1026"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M638.192 936.127a.498.498 0 0 1-.497-.497v-22.415a.498.498 0 0 1 .994 0v22.415a.497.497 0 0 1-.497.497z",
    id: "path1028"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1036"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st187",
    d: "M669.285 928.294a.993.993 0 0 1-.862-.497l-10.846-18.786a.994.994 0 0 1 1.722-.994l10.846 18.786a.994.994 0 0 1-.86 1.491z",
    id: "path1032"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st187",
    d: "M676.154 940.191a.993.993 0 0 1-.862-.497l-3.254-5.636a.994.994 0 0 1 1.722-.994l3.254 5.636a.994.994 0 0 1-.86 1.491z",
    id: "path1034"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st187",
    d: "M576.191 840.572a3.828 3.828 0 0 1-3.824-3.824 3.828 3.828 0 0 1 3.824-3.824 3.828 3.828 0 0 1 3.823 3.824 3.827 3.827 0 0 1-3.823 3.824zm0-5.659a1.838 1.838 0 0 0-1.836 1.836c0 1.013.824 1.836 1.836 1.836a1.838 1.838 0 0 0 1.836-1.836 1.838 1.838 0 0 0-1.836-1.836z",
    id: "path1038"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st187",
    d: "M603.75 854.556a.993.993 0 0 1-.496-.133l-19.412-11.208a.995.995 0 0 1 .994-1.722l19.412 11.208a.995.995 0 0 1-.498 1.855z",
    id: "path1040"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg02Lighting);
export default __webpack_public_path__ + "static/media/02-Lighting.8b1bed8f178697e7e57654a586a5d937.svg";
export { ForwardRef as ReactComponent };